import BreadCrumb from "components/Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Card,
    Col,
    Container,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";
import { useQueryParams } from "use-query-params";
import TabWeatherPlace from "./WeatherPlace";
import TabWeatherArticle from "./WeatherArticle";
import TabWeatherLog from "./WeatherLog";


const NewsWeather = () => {
    const { t, i18n } = useTranslation();

    const [activeTab, setActiveTab] = useState("WEATHER_PLACE");

    const [query, setQuery]: any = useQueryParams({});

    const tabChange = (tab: any) => {
        if (activeTab !== tab) {
            setQuery({}, "push");
            setActiveTab((_prev) => tab);
        }
    };

    useEffect(() => {
        document.title = `${t('News Weather')} - ${t('Boosting Content')} | PRESS Ai`;
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("News Weather")} pageTitle={t("Boosting Content")} />
                    <Row>
                        <Col lg={12}>
                            <Card
                                id="ARTICLE"
                                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                            >
                                <div
                                    style={{
                                        background: "#f3f6f9",
                                        borderTopLeftRadius: "0.6rem",
                                        borderTopRightRadius: "0.6rem",
                                    }}
                                >
                                    <div
                                        className="d-block"
                                        style={{
                                            background: "#f3f6f9",
                                            borderRadius: "0.6rem",
                                            width: "fit-content",
                                        }}
                                    >
                                        <Nav tabs className="nav nav-tabs nav-link-none-hover nav-justified">
                                            <NavItem style={{ minWidth: '140px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "WEATHER_PLACE" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "WEATHER_PLACE" ? "white" : "unset"}`,
                                                        borderTopRightRadius: 0
                                                    }}
                                                    onClick={() => tabChange("WEATHER_PLACE")}
                                                >
                                                    {t("Weather Place")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '140px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "WEATHER_ARTICLE" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "WEATHER_ARTICLE" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("WEATHER_ARTICLE")}
                                                >
                                                    {t("Weather Article")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '110px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "WEATHER_LOG" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "WEATHER_LOG" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("WEATHER_LOG")}
                                                >
                                                    {t("Weather Log")}
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                </div>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="WEATHER_PLACE">
                                        {activeTab === "WEATHER_PLACE" && (<TabWeatherPlace />)}
                                    </TabPane>
                                    <TabPane tabId="WEATHER_ARTICLE">
                                        {activeTab === "WEATHER_ARTICLE" && (<TabWeatherArticle />)}
                                    </TabPane>
                                    <TabPane tabId="WEATHER_LOG">
                                        {activeTab === "WEATHER_LOG" && (<TabWeatherLog />)}
                                    </TabPane>
                                </TabContent>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default NewsWeather;
